import React, { useContext } from 'react';
import { useLaundryBookings } from 'services/laundry/bookings';
import { useIntl } from 'react-intl';
import Loader from 'components/loaders/Loader';
import { formatResourceName } from 'utils/formatResourceName';
import { LaundryBrikkModalContext } from '../../index';
import { BookingCard } from './components/BookingCard';
import styles from './styles.module.scss';

export function BookingsAndRemindersSection({ laundryResources }) {
  const intl = useIntl();
  const { selectedResource } = useContext(LaundryBrikkModalContext);
  const { laundryBookings, isFetching } = useLaundryBookings(
    selectedResource && selectedResource.id,
  );

  if (isFetching) return <Loader />;

  return (
    <div className={styles.cardsSectionWrapper}>
      {laundryBookings.map((booking) => {
        const resource = laundryResources.find(
          (resource) => resource && resource.id === (booking && booking.resourceId),
        );

        return (
          <BookingCard
            key={booking.id}
            bookingId={booking.id}
            date={booking && booking.date}
            address={resource && resource.address}
            name={formatResourceName(resource && resource.name, intl.locale)}
            icon={resource && resource.icon}
            from={booking && booking.from}
            to={booking && booking.to}
            endDate={booking && booking.endDate}
            showRange={booking && booking.endDate}
          />
        );
      })}
    </div>
  );
}
